import React from "react"
import PropTypes from "prop-types"
import BtnPrimary from '../form_sections/BtnPrimary'
import StandardModal from '../app_components/StandardModal'

class ConnectCoinOnboard extends React.Component {
  constructor(props) {
    super(props)

    this.closeOnboard = this.closeOnboard.bind(this)
  }

  closeOnboard() {
    if (this.props.preview) {
      if (this.props.onClose) {
        this.props.onClose()
      }
      return
    }

    $.ajax({
      url: '../turn_off_connect_coin_onboarding',
      type: 'POST'
    })
    window.location.replace("/friends");
  }

  render() {
    return(
      <StandardModal
        onClose={this.closeOnboard}
        title="A welcome gift just for you"
        modalClass="welcomeGiftModal"
      >
        <div className="welcomeGiftModal__content">
          <div className="welcomeGiftModal__header">
            <h4 className="onboardingModalHeader welcomeGiftModal__title">A welcome gift</h4>
            <h4 className="onboardingModalHeader welcomeGiftModal__title">just for you 😍🎁</h4>
          </div>

          <img
            className="welcomeGiftModal__image"
            src={this.props.welcomeGiftImage}
            alt="Three Lexicoins in a gift box"
          />

          <div className="welcomeGiftModal__footer">
            <p className="modalSubHeader welcomeGiftModal__subtitle">
              Use these <span className="welcomeGiftModal__lexicoinLabel">Lexicoins</span> to buy things on Lexody!
            </p>
            <BtnPrimary
              buttonText="Sweet! See my matches."
              onClick={this.closeOnboard}
            />
          </div>
        </div>
      </StandardModal>
    )
  }
}

ConnectCoinOnboard.propTypes = {
  welcomeGiftImage: PropTypes.string.isRequired,
  preview: PropTypes.bool,
  onClose: PropTypes.func,
}

ConnectCoinOnboard.defaultProps = {
  preview: false,
}

export default ConnectCoinOnboard
